import { Button } from '@art-of-hospitality-solutions-llc/ui-kit/components/button';
import {
  Sheet,
  SheetBody,
  SheetClose,
  SheetContent,
  SheetDescription,
  SheetFooter,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from '@art-of-hospitality-solutions-llc/ui-kit/components/sheet';
import { useState } from 'react';
import TicketedEventCategoriesList from '../../../components/TicketedEventCategories/List';
import TicketedEventCategoryForm from '../../../components/TicketedEventCategories/Form';

const FORM_ID = 'create-category-form';

export default function TicketedEventCategories() {
  const [open, setOpen] = useState(false);

  return (
    <div className="p-4">
      <div className="flex justify-between">
        <h1 className="mb-4 text-2xl font-bold">Ticketed Event Categories</h1>
        <Sheet open={open} onOpenChange={setOpen}>
          <SheetTrigger asChild>
            <Button variant="primary">Create new category</Button>
          </SheetTrigger>

          <SheetContent side="right" className="w-full sm:max-w-xl">
            <SheetHeader>
              <SheetTitle>Create category</SheetTitle>
              <SheetDescription>
                Add a new ticketed event category with a name and description.
              </SheetDescription>
            </SheetHeader>

            <SheetBody className="grow">
              <TicketedEventCategoryForm
                onSuccess={() => setOpen(false)}
                submitLabel="Create"
                formId={FORM_ID}
                hideInternalActions
              />
            </SheetBody>

            <SheetFooter className="mt-4">
              <Button type="submit" form={FORM_ID} variant="primary">
                Create
              </Button>
              <SheetClose asChild>
                <Button variant="secondary" type="button">
                  Close
                </Button>
              </SheetClose>
            </SheetFooter>
          </SheetContent>
        </Sheet>
      </div>
      <TicketedEventCategoriesList />
    </div>
  );
}
